// Search Notification

export const bringHomeOptions = [
  { value: 'ASAP', label: 'ASAP' },
  { value: 'In the next month', label: 'In the next month' },
  { value: '1 - 3 months', label: '1 - 3 months' },
  { value: '4 - 6 months', label: '4 - 6 months' },
  { value: '6+ Months', label: '6+ Months' },
]

export const genderOptions = [
  { value: 'Female', label: 'Female' },
  { value: 'Male', label: 'Male' },
]

export const priceRangeOptions = [
  { value: 'Up to $1500', label: 'Up to $1500' },
  { value: 'Up to $3000', label: 'Up to $3000' },
  { value: 'Up to $4500', label: 'Up to $4500' },
  { value: 'Over $4500', label: 'Over $4500' },
]
